import React from 'react';
import ServicePage from '../../components/PublicSite/ServicePage';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';
import loadSiteCopy from '../../components/PublicSite/loadSiteCopy';

async function action() {
  await loadSiteCopy();
  return {
    title: 'Car Wash at Your Location — Sedan, SUV & Bike | Bas Recovery',
    description: 'Your car washed where it is parked. Bike from AED 40, sedan AED 50, SUV AED 75. Water brought with us, no tap or socket needed.',
    component: (
      <HeadLessLayout>
        <ServicePage service="carwash" />
      </HeadLessLayout>
    ),
  };
}

export default action;
